"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerResultState = void 0;
var AnswerResultState;
(function (AnswerResultState) {
    AnswerResultState[AnswerResultState["Correct"] = 0] = "Correct";
    AnswerResultState[AnswerResultState["Incorrect"] = 1] = "Incorrect";
    AnswerResultState[AnswerResultState["Unknown"] = 2] = "Unknown";
})(AnswerResultState || (exports.AnswerResultState = AnswerResultState = {}));
